import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const MENU = [
  { to: '/admin',               icon: '📊', label: 'Dashboard',  end: true },
  { to: '/admin/pedidos',       icon: '📦', label: 'Pedidos' },
  { to: '/admin/produtos',      icon: '🍔', label: 'Produtos' },
  { to: '/admin/adicionais',    icon: '➕', label: 'Adicionais' },
  { to: '/admin/clientes',      icon: '👥', label: 'Clientes' },
  { to: '/admin/fidelidade',    icon: '⭐', label: 'Fidelidade' },
  { to: '/admin/roleta',        icon: '🎰', label: 'Roleta' },
  { to: '/admin/relatorios',    icon: '📈', label: 'Relatórios' },
  { to: '/admin/configuracoes', icon: '🎨', label: 'Visual' },
  { to: '/admin/taxas',         icon: '🛵', label: 'Taxas de Entrega' },
  { to: '/admin/funcionarios',  icon: '👥', label: 'Funcionários' },
  { to: '/admin/mesas',         icon: '🍽️', label: 'Mesas' },
  { to: '/admin/comandas',      icon: '📋', label: 'Comandas' },
  { to: '/admin/entregas',      icon: '🛵', label: 'Entregas' },
  { to: '/admin/credenciais',   icon: '🔐', label: 'Acesso' },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [config, setConfig] = useState({ nome_lanchonete: 'Lanches do Parque', logo_url: null });

  useEffect(() => {
    axios.get('/api/configuracoes/publico').then(r => setConfig(r.data)).catch(() => {});
  }, []);

  return (
    <>
      <style>{`
        html, body, #root { max-width: 100% !important; width: 100% !important; margin: 0 !important; }
        .admin-wrap { display: flex; flex-direction: column; min-height: 100vh; background: var(--bg); width: 100%; }
        .admin-topbar { background: var(--bg2); border-bottom: 1px solid var(--border); padding: 0 24px; height: 56px; display: flex; align-items: center; justify-content: space-between; position: sticky; top: 0; z-index: 200; width: 100%; }
        .admin-body { display: flex; flex: 1; width: 100%; }
        .admin-sidebar { width: 220px; min-width: 220px; background: var(--bg2); border-right: 1px solid var(--border); padding: 16px 8px; display: flex; flex-direction: column; gap: 2px; position: sticky; top: 56px; height: calc(100vh - 56px); overflow-y: auto; flex-shrink: 0; }
        .admin-main { flex: 1; min-width: 0; overflow-x: hidden; }
        .admin-bottom-nav { display: none; }
        @media (max-width: 767px) {
          .admin-sidebar { display: none !important; }
          .admin-bottom-nav { display: flex !important; position: fixed; bottom: 0; left: 0; right: 0; background: var(--bg2); border-top: 1px solid var(--border); height: 58px; z-index: 100; overflow-x: auto; }
          .admin-main { padding-bottom: 58px; }
        }
      `}</style>

      <div className="admin-wrap">
        <header className="admin-topbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {config.logo_url
              ? <img src={`${API_URL}${config.logo_url}`} alt="Logo" style={{ height: 38, width: 38, objectFit: 'contain', borderRadius: 6 }} />
              : <span style={{ fontSize: 22 }}>🍔</span>
            }
            <div>
              <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 18, background: 'linear-gradient(90deg,var(--red),var(--orange))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', lineHeight: 1 }}>
                {config.nome_lanchonete || 'Lanches do Parque'} — ADMIN
              </div>
              <div style={{ fontSize: 10, color: 'var(--text3)', lineHeight: 1 }}>Painel de controle</div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 13, fontWeight: 700 }}>{user?.nome}</div>
              <div style={{ fontSize: 11, color: 'var(--text2)' }}>{user?.email}</div>
            </div>
            <NavLink to="/" style={{ textDecoration: 'none', background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text2)', padding: '6px 12px', borderRadius: 6, fontSize: 12, fontFamily: 'Nunito,sans-serif' }}>🏠 Ver site</NavLink>
            <button onClick={() => { logout(); navigate('/'); }} style={{ background: 'rgba(230,48,48,.15)', border: '1px solid rgba(230,48,48,.3)', color: 'var(--red)', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontFamily: 'Nunito,sans-serif', fontWeight: 700 }}>Sair</button>
          </div>
        </header>

        <div className="admin-body">
          <aside className="admin-sidebar">
            {MENU.map(m => (
              <NavLink key={m.to} to={m.to} end={m.end} style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px',
                borderRadius: 8, textDecoration: 'none', fontSize: 14, fontWeight: 700,
                color: isActive ? '#fff' : 'var(--text2)',
                background: isActive ? 'linear-gradient(90deg,var(--red),var(--orange))' : 'none',
                transition: 'all .15s', marginBottom: 2
              })}>
                <span style={{ fontSize: 18 }}>{m.icon}</span>{m.label}
              </NavLink>
            ))}
            <div style={{ marginTop: 'auto', padding: '14px 6px', borderTop: '1px solid var(--border)' }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)' }}>{user?.nome}</div>
              <div style={{ fontSize: 11, color: 'var(--text3)' }}>{user?.email}</div>
            </div>
          </aside>

          <main className="admin-main">
            <Outlet />
          </main>
        </div>

        <nav className="admin-bottom-nav">
          {MENU.map(m => (
            <NavLink key={m.to} to={m.to} end={m.end} style={({ isActive }) => ({
              flex: '0 0 auto', minWidth: 52,
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
              gap: 2, textDecoration: 'none', padding: '0 6px',
              color: isActive ? 'var(--orange)' : 'var(--text3)',
              fontSize: 9, fontWeight: 700, fontFamily: 'Nunito,sans-serif',
              borderTop: isActive ? '2px solid var(--orange)' : '2px solid transparent'
            })}>
              <span style={{ fontSize: 18 }}>{m.icon}</span>{m.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </>
  );
}
